export class DenouncedActa {
    get id() {
        return this.denouncedActaState.id;
    }
    get diligenceNumber() {
        return this.denouncedActaState.diligenceNumber;
    }
    get denouncedThirId() {
        return this.denouncedActaState.denouncedThirId;
    }
    get bussinessId() {
        return this.denouncedActaState.bussinessId;
    }
    get vehicleId() {
        return this.denouncedActaState.vehicleId;
    }
    get userId() {
        return this.denouncedActaState.userId;
    }
    get vehicleDamage() {
        return this.denouncedActaState.vehicleDamage;
    }
    get trailerPlate() {
        return this.denouncedActaState.trailerPlate;
    }
    get directionId() {
        return this.denouncedActaState.directionId;
    }
    set diligenceNumber(diligenceNumber) {
        this.denouncedActaState.diligenceNumber = diligenceNumber;
    }
    set denouncedThirId(denouncedThirId) {
        this.denouncedActaState.denouncedThirId = denouncedThirId;
    }
    set bussinessId(bussinessId) {
        this.denouncedActaState.bussinessId = bussinessId;
    }
    set vehicleId(vehicleId) {
        this.denouncedActaState.vehicleId = vehicleId;
    }
    set userId(userId) {
        this.denouncedActaState.userId = userId;
    }
    set vehicleDamage(vehicleDamage) {
        this.denouncedActaState.vehicleDamage = vehicleDamage;
    }
    set trailerPlate(trailerPlate) {
        this.denouncedActaState.trailerPlate = trailerPlate;
    }
    set directionId(directionId) {
        this.denouncedActaState.directionId = directionId;
    }
    constructor(denouncedActaState) {
        this.denouncedActaState = denouncedActaState;
    }
    getState() {
        return this.denouncedActaState;
    }
}
